import React from 'react';
import { FadeIn } from './Shared';
import { Scale } from 'lucide-react';
export const CostComparison = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/30 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-46">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-47">
        <FadeIn data-id="element-48">
          <div className="text-center mb-16" data-id="element-49">
            <div className="inline-flex items-center justify-center bg-orange-500/10 px-4 py-2 rounded-full border border-orange-500/20 mb-6" data-id="element-50">
              <Scale className="w-6 h-6 text-orange-400 mr-3" data-id="element-51" />
              <span className="text-orange-400 font-bold tracking-[0.2em] text-xs uppercase" data-id="element-52">
                LA BALANZA
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-53">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-navy-950 rounded-3xl border border-white/10 overflow-hidden" data-id="element-54">
            <div className="w-full" data-id="element-55">
              {/* Header */}
              <div className="grid grid-cols-2 bg-navy-900 border-b border-white/10" data-id="element-56">
                <div className="py-4 md:py-8 px-4 md:px-8 text-red-400 font-bold text-[10px] md:text-sm uppercase tracking-widest border-r border-white/5 flex items-center" data-id="element-57">
                  Sin Método Silencio Total
                </div>
                <div className="py-4 md:py-8 px-4 md:px-8 text-orange-400 font-bold text-[10px] md:text-sm uppercase tracking-widest flex items-center" data-id="element-58">
                  Costo real
                </div>
              </div>

              {/* Body */}
              <div className="divide-y divide-white/5" data-id="element-59">
                {[['Cada ladrido sin sistema', 'Culpa acumulada + relación con el edificio desgastada'], ['Volver porque lloraba esta semana', 'Le enseñaste exactamente que llorar funciona'], ['Ceder por vergüenza social', 'Reforzaste el comportamiento que más querés eliminar'], ['No saber si lo que hacés ayuda', 'Improvisación que casi siempre escala el problema'], ['La nota del consorcio que no sabés cómo responder', 'Conflicto edilicio sin herramientas para manejarlo'], ['El domingo angustiado por la semana que viene', 'El mismo ciclo el próximo lunes']].map(([sin, costo], i) => <div key={i} className="grid grid-cols-2 transition-colors hover:bg-white/[0.02]" data-id="element-60">
                    <div className="py-4 md:py-6 px-4 md:px-8 text-gray-300 border-r border-white/5 font-medium font-sans text-xs md:text-base leading-relaxed flex items-center" data-id="element-61">
                      {sin}
                    </div>
                    <div className="py-4 md:py-6 px-4 md:px-8 text-gray-100 font-sans font-medium text-xs md:text-lg leading-relaxed flex items-center" data-id="element-62">
                      {costo}
                    </div>
                  </div>)}
              </div>

              {/* Footer */}
              <div className="bg-navy-900/80 border-t-2 border-orange-500/30 py-8 md:py-12 px-6 md:px-8 text-center" data-id="element-63">
                <span className="text-lg md:text-4xl font-bold text-white leading-tight font-[Montserrat,_sans-serif]" data-id="element-64">
                  La próxima vez que cerrés la puerta{' '}
                  <span className="text-orange-400" data-id="element-65">
                    puede haber silencio del otro lado.
                  </span>
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};